import images from "./images";

const portfolio = [
    {
        id: 1,
        image: images.portfolio1,
        title: "Window Installations",
        details: {
            date: "February 2, 2024",
            client: "General Public",
            category: "Installation Services",
            duration: "Varies based on project scope",
            location: "Nationwide Window Installations",
            cost: "Depends on window types and quantity",
            leadSpecialist: "Michael Windowsmith"
        },
        paragraphs: [
            "Upgrade your home with our professional window installation services. We offer a wide range of window options and ensure precise installation for enhanced aesthetics and functionality.",
            "Our team specializes in providing top-notch window installation services tailored to meet your specific needs. Whether you're looking to replace old windows or install new ones, we have the expertise and tools to deliver exceptional results."
        ],
        gallery: [
            images.portfolio1Gallery1,
            images.portfolio1Gallery2,
            images.portfolio1Gallery3,
            images.portfolio1Gallery4,
            images.portfolio1Gallery5,
            images.portfolio1Gallery6
        ],
        challenges: [
            "Assessment of Window Needs",
            "Selection of Suitable Window Styles",
            "Professional Installation Techniques"
        ],
        solutions: [
            "High-Quality Window Materials",
            "Energy-Efficient Window Options",
            "Customized Window Solutions"
        ],
        results: [
            "Enhanced Home Aesthetics",
            "Improved Energy Efficiency",
            "Increased Property Value"
        ],
    },
    {
        id: 2,
        image: images.portfolio2,
        title: "Window Frame Repairs",
        details: {
            date: "March 14, 2024",
            client: "Residential and Commercial Clients",
            category: "Repair Services",
            duration: "Depends on damage severity and frame type",
            location: "Citywide and Nearby Areas",
            cost: "Based on repair complexity and materials used",
            leadSpecialist: "Emma Framewright"
        },
        paragraphs: [
            "Restore the strength and appearance of your windows with our expert frame repair services. We handle everything from minor fixes to major frame overhauls to ensure your windows function properly and look great.",
            "Our technicians specialize in repairing damaged, warped, or rotted window frames using durable materials and precise techniques. We work with all window types and styles to extend their lifespan and enhance overall efficiency."
        ],
        gallery: [
            images.portfolio2Gallery1,
            images.portfolio2Gallery2,
            images.portfolio2Gallery3,
            images.portfolio2Gallery4,
            images.portfolio2Gallery5,
            images.portfolio2Gallery6
        ],
        challenges: [
            "Identifying Hidden Frame Damage",
            "Matching Frame Styles and Finishes",
            "Ensuring Structural Integrity"
        ],
        solutions: [
            "In-depth Frame Inspections",
            "Use of High-Quality Repair Materials",
            "Precision Repair and Reinforcement Techniques"
        ],
        results: [
            "Extended Frame Life",
            "Improved Window Stability",
            "Restored Aesthetic Appeal"
        ],
    },
    {
        id: 3,
        image: images.portfolio3,
        title: "Door Installations",
        details: {
            date: "April 5, 2024",
            client: "Homeowners and Commercial Clients",
            category: "Installation Services",
            duration: "Varies by door type and number of installations",
            location: "Regional Door Installation Services",
            cost: "Based on door style, material, and quantity",
            leadSpecialist: "David Doorman"
        },
        paragraphs: [
            "Secure and beautify your property with our professional door installation services. From front entry doors to interior and patio doors, we ensure each installation is performed with precision and care.",
            "Our team brings years of experience to every project, handling different materials like wood, steel, fiberglass, and glass. We focus on flawless fitting, proper insulation, and enhanced durability for every door we install."
        ],
        gallery: [
            images.portfolio3Gallery1,
            images.portfolio3Gallery2,
            images.portfolio3Gallery3,
            images.portfolio3Gallery4,
            images.portfolio3Gallery5,
            images.portfolio3Gallery6
        ],
        challenges: [
            "Accurate Door Frame Measurements",
            "Ensuring Smooth Door Operation",
            "Aligning with Architectural Style"
        ],
        solutions: [
            "Precision Installation Methods",
            "Weatherproof Sealing and Finishing",
            "Custom Door Fitting and Adjustments"
        ],
        results: [
            "Improved Security and Accessibility",
            "Enhanced Property Appearance",
            "Long-Lasting Door Performance"
        ],
    },
    {
        id: 4,
        image: images.portfolio4,
        title: "Custom Window Designs",
        details: {
            date: "May 12, 2024",
            client: "Architects and Property Owners",
            category: "Customization Services",
            duration: "Depends on design complexity and order size",
            location: "Available in select regions and by request",
            cost: "Custom quotes based on design and materials",
            leadSpecialist: "Emily Glassford"
        },
        paragraphs: [
            "Transform your space with our custom window design services tailored to your architectural vision. We specialize in unique shapes, styles, and finishes that bring elegance and functionality together.",
            "From concept to creation, we work closely with clients to craft one-of-a-kind window designs that enhance both the aesthetic and efficiency of any space. Whether it's for a modern build or historic renovation, we bring your vision to life."
        ],
        gallery: [
            images.portfolio4Gallery1,
            images.portfolio4Gallery2,
            images.portfolio4Gallery3,
            images.portfolio4Gallery4,
            images.portfolio4Gallery5,
            images.portfolio4Gallery6
        ],
        challenges: [
            "Aligning Design with Structural Requirements",
            "Balancing Aesthetics and Functionality",
            "Material and Glass Customization"
        ],
        solutions: [
            "Collaborative Design Consultations",
            "Advanced Fabrication Techniques",
            "Tailored Finishes and Glazing Options"
        ],
        results: [
            "Unique and Stylish Window Features",
            "Enhanced Visual Appeal",
            "Boosted Property Value and Efficiency"
        ],
    },
    {
        id: 5,
        image: images.portfolio5,
        title: "Glass Pane Repairs",
        details: {
            date: "May 12, 2024",
            client: "Homeowners and Businesses",
            category: "Repair Services",
            duration: "Typically completed within a day",
            location: "Local and surrounding service areas",
            cost: "Varies based on glass type and damage severity",
            leadSpecialist: "Alex Clearwell"
        },
        paragraphs: [
            "Restore the clarity and safety of your windows with our expert glass pane repair services. We handle cracks, chips, and shattered panes efficiently and with minimal disruption to your space.",
            "Our technicians are trained to work with all types of glass, ensuring a perfect match and secure installation every time. Whether it's a minor repair or full pane replacement, we’ve got you covered."
        ],
        gallery: [
            images.portfolio5Gallery1,
            images.portfolio5Gallery2,
            images.portfolio5Gallery3,
            images.portfolio5Gallery4,
            images.portfolio5Gallery5,
            images.portfolio5Gallery6
        ],
        challenges: [
            "Matching Glass Type and Thickness",
            "Ensuring Structural Integrity Post-Repair",
            "Minimizing Downtime During Repairs"
        ],
        solutions: [
            "On-Site Assessment and Rapid Response",
            "Use of High-Quality Replacement Glass",
            "Precision Cutting and Seamless Integration"
        ],
        results: [
            "Restored Window Functionality",
            "Improved Safety and Insulation",
            "Quick and Hassle-Free Service Experience"
        ],
    },
    {
        id: 6,
        image: images.portfolio6,
        title: "Custom Door Designs",
        details: {
            date: "May 12, 2024",
            client: "Residential and Commercial Clients",
            category: "Customization Services",
            duration: "Timeline varies based on design complexity",
            location: "Customized solutions available nationwide",
            cost: "Pricing depends on design, material, and size",
            leadSpecialist: "Emma Doorson"
        },
        paragraphs: [
            "Transform your entryways with our beautifully crafted custom door designs tailored to your style and architectural needs. We create unique doors that reflect your personal taste while ensuring durability and functionality.",
            "From elegant front doors to sleek interior panels, our custom designs blend aesthetics with practicality. Whether modern or traditional, we bring your vision to life using premium materials and expert craftsmanship."
        ],
        gallery: [
            images.portfolio6Gallery1,
            images.portfolio6Gallery2,
            images.portfolio6Gallery3,
            images.portfolio6Gallery4,
            images.portfolio6Gallery5,
            images.portfolio6Gallery6
        ],
        challenges: [
            "Translating Client Vision into Functional Design",
            "Material Selection Based on Durability and Style",
            "Precise Crafting and Fitment"
        ],
        solutions: [
            "Collaborative Design Consultations",
            "Access to a Wide Range of Materials and Finishes",
            "Expert Fabrication and Installation"
        ],
        results: [
            "Unique and Personalized Door Designs",
            "Enhanced Aesthetic Appeal",
            "Long-Lasting and Functional Installations"
        ],
    }

];

export default portfolio;